import { IntroductionDetails } from '@platform/client/schemas';
import {
  OrganizationProfileLink,
  ProfileItem,
  ProfileItemLong,
  ProfileLinkExternal,
  ProfileSection,
  ProfileTabContainer,
  ProjectProfileLink,
  ProUserProfileLink,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { formatUserFirstLast } from '../../../util/TextHelpers';

export const DetailsTabContent = ({ introData }: { introData?: IntroductionDetails }) => {
  return (
    <ProfileTabContainer>
      <ProfileSection>
        <OrganizationProfileLink
          organizationId={introData?.organization.id}
          organizationName={introData?.organization.name}
        />
        <ProUserProfileLink
          userId={introData?.professional.id}
          firstname={introData?.professional.firstName}
          lastname={introData?.professional.lastName}
        />
        <ProjectProfileLink
          projectId={introData?.project?.id}
          projectName={introData?.project?.name}
        />
        <ProfileItem label='Professional Cohort' value={introData?.professional.cohortName} />
        <ProfileItem
          label='Representative'
          value={formatUserFirstLast(
            introData?.representative.firstName,
            introData?.representative.lastName,
          )}
        />
        <ProfileItem label='Match Status' value={introData?.myProjectsStatus} />
        <ProfileItem label='Sent by' value={introData?.initiationType} />
        <ProfileItem
          label='Status Date'
          value={
            introData?.myProjectsStatusDate ?
              formatDateStr(introData?.myProjectsStatusDate)
            : undefined
          }
        />
        <ProfileItem
          label='Sent'
          value={introData?.createdAt ? formatDateStr(introData.createdAt) : undefined}
        />
        <ProfileLinkExternal label='Planning guide' href={introData?.planningGuideUrl} />
      </ProfileSection>
      <ProfileSection columns={1}>
        <ProfileItemLong label='Message' value={introData?.message} />
      </ProfileSection>
    </ProfileTabContainer>
  );
};
